
function applyLightGalleryFix() {
    if (!window.jQuery || !window.jQuery.fn.lightGallery || !window.jQuery.fn.lightGallery.modules.video) {
        return;
    }

    const Video = window.jQuery.fn.lightGallery.modules.video;

    if (Video.prototype.loadVideo_patched) {
        return;
    }

    const originalLoadVideo = Video.prototype.loadVideo;

    Video.prototype.loadVideo = function () {
        // Call the original method
        let html = originalLoadVideo.apply(this, arguments);

        // Check if the result is an iframe string and needs patching
        if (typeof html === 'string' && html.includes('<iframe') && !html.includes('allow="')) {
            const required = 'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"';
            // Insert the allow attribute before the closing > of the opening tag
            // The original string looks like: <iframe ... frameborder="0" allowfullscreen></iframe>
            // We can replace 'allowfullscreen' with 'allowfullscreen ' + required
            // Or just replace 'src=' with 'allow="' + required + '" src=' (order doesn't matter much)
            // Let's replace 'allowfullscreen' which we know is there from the source

            if (html.includes('allowfullscreen')) {
                html = html.replace('allowfullscreen', `allowfullscreen ${required}`);
            } else {
                // Fallback if allowfullscreen is missing for some reason (e.g. vimeo might be different)
                html = html.replace('<iframe', `<iframe ${required}`);
            }

            // Also ensure 'origin' parameter is present in src for YouTube to fix some policy issues
            if (html.includes('youtube.com/embed')) {
                // Force HTTPS
                html = html.replace('//www.youtube.com', 'https://www.youtube.com');

                if (!html.includes('origin=')) {
                    const origin = window.location.origin;
                    html = html.replace('enablejsapi=1', `enablejsapi=1&origin=${origin}`);
                }
            }
        }

        return html;

    };

    Video.prototype.loadVideo_patched = true;
}

document.addEventListener('DOMContentLoaded', applyLightGalleryFix);
document.addEventListener('turbolinks:load', applyLightGalleryFix);
document.addEventListener('turbo:load', applyLightGalleryFix);

// Also try immediately in case jQuery is already ready
if (window.jQuery && window.jQuery.fn.lightGallery) {
    applyLightGalleryFix();
}
